
export class Category {
    _id: string;
    name: string;
    description: string;
    company: string;
    branch: string;
    code:string;
}